// extracted by mini-css-extract-plugin
export var brand = "styles-module--brand--Jiu8q";
export var burgerIcon = "styles-module--burgerIcon--a5ffz";
export var container = "styles-module--container--vzrwR";
export var hamburger = "styles-module--hamburger--iy1+M";
export var header = "styles-module--header--a+NL6";